import { gql } from "@apollo/client"

const GET_LOCATIONS = gql`
  query($clientId: ID!) { 
    locations(client_id: $clientId) {
      id
      name
    }
  }
`

export { GET_LOCATIONS }